export default "__VITE_ASSET__BiVl94dg__"